var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"solent-spinner-row"},[_c('circle2',{staticClass:"solent-spinner"})],1),_c('h1',[_vm._v("Client Panel")]),_c('h1',[_vm._v("Token: ")]),_c('h3',{domProps:{"textContent":_vm._s(_vm.token)}}),_c('h1',[_vm._v("Expired At: ")]),_c('h3',{domProps:{"textContent":_vm._s(_vm.expiredAt)}}),_c('h1',[_vm._v(" End ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }